import './App.css';
import { BrowserRouter as Router, Route, Link, Routes, Navigate, useHistory, useLocation } from 'react-router-dom';
import React,{ useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Countdown from './Countdown.js';

class App extends React.Component {
  constructor(props){
    super(props);
  }
  render() {     
    return (
    <div className="App">
      <Router>        
        <Routes>
          <Route exact path="*" element = {<ShowCoutdown/> } />                            
        </Routes>
      </Router>

      <Footer />      
    </div>
    );  
  }
}

function ShowCoutdown() {
  let nav = useNavigate();   
  return (
    <Countdown navigate={nav}/>
  )
}

function ShowStaticInformation() {
  let nav = useNavigate();   
  return (
    <div className='appStaticInfocontainer'>
      <div id="title">
        Gaidām svētkus kopā!
      </div>
      <div id='body'>
        Nokavēji 1.decembri? Gribi pievienoties?
      </div>
      <div id='body'>        
        Uzraksti mums: <u>info@piikpok.family</u>
      </div>      
    </div>
  )  
}

function Footer() {
  return (    
    <div className="appFooter">
      © 2022, SIA Rotaat & PiiPok radošā komanda
    </div>
  )
}

export default App;
